<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="row">
  <div class="col-md-12 wccard py-4">

    <div class="col d-flex justify-content-between">
      <span class="f-14 font-weight-500">Profile Details</span>
      <span class="trx pointer text-bluex">
        <span *ngIf="(ProfileDetails && ProfileDetails.registeredvia != 'google' && ProfileDetails.registeredvia != 'linkedin')" class="mr-4" (click)="changepasswordmodal()"> Change Password </span>
        <i class="fas fa-edit webtree-btn" (click)="EditProfileDetails()"></i></span>
    </div>

    <div class="col-md-12 d-flex pl-0 mt-4">
      <div class="col-md-4 gray-text f-12">
        First Name
        <p class="txt-prim f-14">
          {{ProfileDetails?.firstname}}
        </p>
      </div>

      <div class="col-md-4 gray-text f-12">Last Name
        <p class="txt-prim f-14">
          {{ProfileDetails?.lastname}}

        </p>
      </div>
    </div>

    <div class="col-md-12 d-flex pl-0 mt-4">

      <div class="col-md-4 gray-text f-12">
        Phone Number
        <p class="txt-prim f-14">
          {{ProfileDetails?.extn}}

        </p>
      </div>

      <div class="col-md-4 gray-text f-12">Email Id
        <p class="txt-prim f-14">
          {{ProfileDetails?.loginemail}}

        </p>
      </div>
    </div>


    <div class="col-md-12 d-flex pl-0 mt-4">
      <div class="col-md-4 gray-text f-12">designation
        <p class="txt-prim f-14">
          {{ProfileDetails?.designation}}

        </p>
      </div>

      <div class="col-md-4 gray-text f-12">Company Name
        <p class="txt-prim f-14">
          {{ProfileDetails?.company}}

        </p>
      </div>
    </div>
  </div>
</div>


<ngb-alert class="ngb-alert" *ngIf="successMessage" type="success" (close)="successMessage = ''">
  <span class="successCheck"><i class="fal fa-check"></i> </span>
  <span class="successmsg">{{ successMessage }}</span>
</ngb-alert>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
